/**
 * @generated SignedSource<<7fb6e4b84e981cea526f15553c18a302>>
 * @relayHash 467fb997baff7898efacba57030234d3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eda4dc89a121a5bc1b0d1b38176fb11d857c3c4393cc85125be623e5a4d205b5

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraContainerNavigationQueryInput = {
  projectKeyAndItemIdQuery?: JiraContainerNavigationByProjectKeyAndItemIdQueryInput | null;
  projectKeyQuery?: JiraContainerNavigationByProjectKeyQueryInput | null;
  scopeId?: string | null;
};
export type JiraContainerNavigationByProjectKeyAndItemIdQueryInput = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type JiraContainerNavigationByProjectKeyQueryInput = {
  cloudId: string;
  projectKey: string;
};
export type HorizontalNavJiraInnerQuery$variables = {
  boardId: string;
  cloudId: string;
  containerNavigationInput: JiraContainerNavigationQueryInput;
  first: number;
  projectIdOrKey: string;
  skipMostRecentlyViewedBoard: boolean;
  withBoard: boolean;
  withProject: boolean;
  withResolvedBoard: boolean;
};
export type HorizontalNavJiraInnerQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JiraHorizontalNavigationContent_query">;
};
export type HorizontalNavJiraInnerQuery = {
  response: HorizontalNavJiraInnerQuery$data;
  variables: HorizontalNavJiraInnerQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": isJiraExternalGuestsSpaceFlagEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider": isJiraCreateViewWithRovoEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider": isJiraAgenticSummaryViewEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNavBoardHeaderFragmentRelayProvider": isBoardActionsFragmentEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider": includeAddAgents_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcCustomTemplateForStandardAndPremiumRelayProvider": isCustomTemplateForStandardAndPremiumEnabled_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAdminAgentM2ChampionFlowRelayProvider": includeAdminAgentChampionRequests_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcCustomTemplateForStandardAndPremiumRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAdminAgentM2ChampionFlowRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNavBoardHeaderFragmentRelayProvider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider: {
    readonly get: () => boolean;
  };
});

import includeAddAgents_provider from '@jira/platform__graphql-relay-provider/src/AutonomousAgentsInSpaceRelayProvider';
import isCustomTemplateForStandardAndPremiumEnabled_provider from '@jira/platform__graphql-relay-provider/src/CustomTemplateForStandardAndPremiumRelayProvider';
import includeAdminAgentChampionRequests_provider from '@jira/platform__graphql-relay-provider/src/JiraAdminAgentM2ChampionFlowRelayProvider';
import isJiraAgenticSummaryViewEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraAgenticSummaryViewRelayProvider';
import isJiraExternalGuestsSpaceFlagEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraExternalGuestsSpaceFlagRelayprovider';
import isBoardActionsFragmentEnabled_provider from '@jira/platform__graphql-relay-provider/src/NavBoardHeaderFragmentRelayProvider';
import isJiraCreateViewWithRovoEnabled_provider from '@jira/platform__graphql-relay-provider/src/Sea3716JiraCreateViewWithRovoRelayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerNavigationInput"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipMostRecentlyViewedBoard"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withBoard"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withProject"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "withResolvedBoard"
},
v9 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "containerNavigationInput"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "kind": "ScalarField",
  "name": "url"
},
v13 = {
  "kind": "ScalarField",
  "name": "label"
},
v14 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v15 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v16 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v17 = [
  (v16/*: any*/)
],
v18 = [
  {
    "kind": "ScalarField",
    "name": "message"
  },
  {
    "kind": "LinkedField",
    "name": "extensions",
    "plural": true,
    "selections": [
      (v10/*: any*/),
      {
        "kind": "ScalarField",
        "name": "statusCode"
      }
    ]
  }
],
v19 = {
  "kind": "ScalarField",
  "name": "canEdit"
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v11/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v21 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v22 = [
  (v21/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "name"
},
v24 = {
  "kind": "ScalarField",
  "name": "boardId"
},
v25 = {
  "kind": "ScalarField",
  "name": "boardType"
},
v26 = {
  "concreteType": "JiraFavouriteValue",
  "kind": "LinkedField",
  "name": "favouriteValue",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    (v11/*: any*/)
  ]
},
v27 = {
  "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNavBoardHeaderFragmentRelayProvider",
  "kind": "Condition",
  "passingValue": false,
  "selections": (v17/*: any*/)
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "HorizontalNavJiraInnerQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "JiraHorizontalNavigationContent_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNavBoardHeaderFragmentRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcCustomTemplateForStandardAndPremiumRelayProvider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAdminAgentM2ChampionFlowRelayProvider"
      }
    ],
    "kind": "Operation",
    "name": "HorizontalNavJiraInnerQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "kind": "LinkedField",
            "name": "containerNavigation",
            "plural": false,
            "selections": [
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraContainerNavigationResult"
              },
              (v10/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v11/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "scopeId"
                  },
                  {
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "first",
                        "variableName": "first"
                      }
                    ],
                    "concreteType": "JiraNavigationItemConnection",
                    "kind": "LinkedField",
                    "name": "navigationItems",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraNavigationItemEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isDefault"
                              },
                              (v12/*: any*/),
                              (v11/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "typeKey"
                              },
                              (v13/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isJiraNavigationItem"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRename"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canRemove"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canSetAsDefault"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "alias": "scopedUrl",
                                    "kind": "ScalarField",
                                    "name": "url"
                                  }
                                ],
                                "type": "JiraSoftwareBuiltInNavigationItem"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "appId"
                                  },
                                  {
                                    "concreteType": "JiraAppSection",
                                    "kind": "LinkedField",
                                    "name": "sections",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "concreteType": "JiraAppNavigationItemNestedLink",
                                        "kind": "LinkedField",
                                        "name": "links",
                                        "plural": true,
                                        "selections": [
                                          (v12/*: any*/),
                                          (v13/*: any*/),
                                          (v14/*: any*/),
                                          (v15/*: any*/)
                                        ]
                                      },
                                      (v13/*: any*/)
                                    ]
                                  },
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "envLabel"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v17/*: any*/),
                                    "type": "JiraNavigationItem",
                                    "abstractKey": "__isJiraNavigationItem"
                                  }
                                ],
                                "type": "JiraAppNavigationItem"
                              },
                              (v16/*: any*/)
                            ]
                          },
                          (v10/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "QueryError",
                        "kind": "LinkedField",
                        "name": "errors",
                        "plural": true,
                        "selections": (v18/*: any*/)
                      }
                    ]
                  },
                  (v19/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "scopeUrl"
                  }
                ],
                "type": "JiraContainerNavigation"
              },
              {
                "kind": "InlineFragment",
                "selections": (v18/*: any*/),
                "type": "QueryError"
              },
              (v20/*: any*/)
            ]
          },
          {
            "args": (v22/*: any*/),
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v22/*: any*/),
                "concreteType": "JiraRovoEnablementStatus",
                "kind": "LinkedField",
                "name": "rovoEnablementStatus",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "rovoAiFeaturesEnabledJiraProducts"
                  }
                ]
              }
            ]
          },
          {
            "condition": "withResolvedBoard",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v9/*: any*/),
                "kind": "LinkedField",
                "name": "containerNavigation",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "scope",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v19/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ],
                            "type": "JiraBoard"
                          },
                          (v20/*: any*/)
                        ]
                      }
                    ],
                    "type": "JiraContainerNavigation"
                  },
                  (v20/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "withBoard",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "boardId"
                  }
                ],
                "kind": "LinkedField",
                "name": "jiraBoard",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v23/*: any*/),
                      (v11/*: any*/),
                      (v24/*: any*/),
                      (v19/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "type": "JiraBoard"
                  },
                  (v20/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "withProject",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v21/*: any*/),
              {
                "kind": "Variable",
                "name": "idOrKey",
                "variableName": "projectIdOrKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jira_projectByIdOrKey",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "large"
                  }
                ]
              },
              {
                "alias": "canEditProjectConfig",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canPerform"
                  }
                ],
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              },
              (v11/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectStyle"
              },
              (v23/*: any*/),
              {
                "alias": "projectKey",
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "softwareBoardCount"
              },
              {
                "kind": "ScalarField",
                "name": "isLiveTemplate"
              },
              {
                "kind": "ScalarField",
                "name": "isLiveTemplateEligible"
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAdminAgentM2ChampionFlowRelayProvider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isAdminAgentChampionRequestsEnabled"
                  }
                ]
              },
              {
                "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcCustomTemplateForStandardAndPremiumRelayProvider",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "isLiveTemplateUpsellEligible"
                  }
                ]
              },
              {
                "condition": "skipMostRecentlyViewedBoard",
                "kind": "Condition",
                "passingValue": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "mostRecentlyViewedBoard",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v24/*: any*/),
                          (v23/*: any*/),
                          (v19/*: any*/),
                          (v25/*: any*/),
                          (v26/*: any*/),
                          (v27/*: any*/)
                        ],
                        "type": "JiraBoard"
                      },
                      (v20/*: any*/)
                    ]
                  }
                ]
              },
              (v16/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "eda4dc89a121a5bc1b0d1b38176fb11d857c3c4393cc85125be623e5a4d205b5",
    "metadata": {},
    "name": "HorizontalNavJiraInnerQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraExternalGuestsSpaceFlagRelayprovider": isJiraExternalGuestsSpaceFlagEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcSea3716JiraCreateViewWithRovoRelayprovider": isJiraCreateViewWithRovoEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAgenticSummaryViewRelayProvider": isJiraAgenticSummaryViewEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcNavBoardHeaderFragmentRelayProvider": isBoardActionsFragmentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcAutonomousAgentsInSpaceRelayProvider": includeAddAgents_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcCustomTemplateForStandardAndPremiumRelayProvider": isCustomTemplateForStandardAndPremiumEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraAdminAgentM2ChampionFlowRelayProvider": includeAdminAgentChampionRequests_provider
    }
  }
};
})();

(node as any).hash = "6e4193a5518b2852827f27aad30c8344";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
